
import DashboardPage from '../pages/dashboard/page';
import NotFoundPage from '../pages/NotFound';

const routes = [
  {
    path: '/',
    element: <DashboardPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
